import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import FormControlLabel from '@mui/material/FormControlLabel'
import Switch from '@mui/material/Switch'
import Typography from '@mui/material/Typography'
import { useSelector } from 'react-redux'
import Alert from '@mui/material/Alert'
import ButtonStartIcon from '../../../../button/ButtonStartIcon'
import { Table, TableBody, TableRow, TableCell } from '@mui/material'
import { updateReadOnly } from '../../../../../services/tenant/tenant.service'
import { handlerErrorV2 } from '../../../../../utils/errors'
import { useSnackbar } from 'notistack'

const moduleOptions = [
  { key: 'users', label: 'Users' },
  { key: 'classes', label: 'Classes' },
  { key: 'subjects', label: 'Subjects' },
  { key: 'yearLevels', label: 'Year levels' }
]

const ReadOnly = ({ data, permission = false }) => {
  const { enqueueSnackbar } = useSnackbar()

  const [loading, toggleLoading] = useState(false)
  const [inputErrors, setInputErrors] = useState({})
  const [moduleSettings, setModuleSettings] = useState(
    data || {
      users: false,
      classes: false,
      subjects: false
    }
  )

  const onSave = async (e) => {
    e.preventDefault()
    setInputErrors({})

    try {
      toggleLoading(true)
      const result = await updateReadOnly(moduleSettings)
      if (!result.data && result.error) {
        setInputErrors({
          message: result.error.message || 'Something went wrong. Please try again.'
        })
      } else {
        enqueueSnackbar('Updated successfully', { variant: 'success' })
      }
    } catch (error) {
      const message = handlerErrorV2(error)
      setInputErrors({ message })
    } finally {
      toggleLoading(false)
    }
  }

  const handleToggleModule = (moduleKey) => {
    setModuleSettings((prevState) => ({
      ...prevState,
      [moduleKey]: !prevState[moduleKey]
    }))
  }

  useEffect(() => {
    setModuleSettings(
      data || {
        users: false,
        classes: false,
        subjects: false
      }
    )
  }, [data])
  return (
    <>
      <Box className='bg-primary text-primary-foreground px-4 py-1 flex gap-4 items-center justify-between sticky top-0 z-10 h-8'>
        <Typography variant='subtitle1' className='uppercase'>
          Read Only
        </Typography>
        {permission && (
          <ButtonStartIcon
            onClick={onSave}
            color='secondary'
            variant='contained'
            startIcon={['fal', 'check']}
            loading={loading}
          >
            save
          </ButtonStartIcon>
        )}
      </Box>
      <Box className='px-2 py-2'>
        <Box className='mt-4 flex flex-col gap-3'>
          <Typography className='font-semibold text-muted-foreground opacity-80 px-2'>
            Enable read-only access for these entities. Users cannot create, edit, or delete these records.
            Recommended for records synced from other systems to prevent data discrepancies.
          </Typography>
          {inputErrors.message && (
            <Alert severity='error' className='mb-2'>
              {inputErrors.message}
            </Alert>
          )}
          <Table>
            <TableBody>
              {moduleOptions.map((module) => (
                <TableRow key={module.key}>
                  <TableCell>
                    <Box className='px-2 py-1'>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={moduleSettings[module.key]}
                            onChange={() => (permission ? handleToggleModule(module.key) : null)}
                            color='primary'
                            size='small'
                            readOnly={!permission}
                          />
                        }
                        label={module.label}
                        readOnly={!permission}
                        labelPlacement='end'
                      />
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </Box>
    </>
  )
}

export default ReadOnly
